module.exports = __webpack_public_path__ + "static/media/agc010.02b78ff3.jpg";